import { AppRoute, authGuard, goToDashboardIfLoggedIn, isEinreichungV3ActivatedGuard } from '@ebeihilfe/core';
import { DashboardComponent } from './feature/pages/dashboard/dashboard.component';
import { HelpComponent } from './feature/pages/help/help.component';
import { LoginComponent } from './feature/pages/login/login.component';
import { NotFound404Component } from './components/not-found-404/not-found-404.component';
import { ResetPasswordComponent } from './feature/pages/reset-password/reset-password.component';
import { Routes } from '@angular/router';
import { StartPageComponent } from './feature/pages/start-page/start-page.component';
import { hasSecondFactor } from './guards/has-second-factor/has-second-factor.guard';

const startPageTitle = 'page_names.startseite';
export const routes: Routes = [
  {
    path: AppRoute.PinValidation,
    loadComponent: () => import('./feature/pin').then((c) => c.PinSaverComponent),
    canActivate: [authGuard],
    data: { title: 'page_names.save-pin' },
  },
  {
    path: AppRoute.UnfinishedRegistration,
    loadComponent: () => import('./feature/unfinished-registration').then((c) => c.InitialLoadComponent),
    data: { title: 'page_names.registration-unfinished' },
  },
  {
    path: AppRoute.Login,
    component: LoginComponent,
    canActivate: [goToDashboardIfLoggedIn],
    data: { title: 'page_names.login' },
  },
  {
    path: AppRoute.CallbackLogin,
    redirectTo: AppRoute.Login,
  },
  {
    path: AppRoute.Logout,
    loadChildren: () => import('./feature/logout-page/logout-page.module').then((m) => m.LogoutPageModule),
    data: { title: 'page_names.logout' },
  },
  {
    path: AppRoute.CallbackLogout,
    redirectTo: AppRoute.Logout,
  },
  {
    path: AppRoute.PasswordForgotten,
    loadChildren: () =>
      import('./feature/password-forgotten/password-forgotten.module').then((m) => m.PasswordForgottenModule),
    data: { title: 'page_names.password_forgotten' },
  },
  {
    path: AppRoute.ResetPassword,
    component: ResetPasswordComponent,
    data: { title: 'page_names.reset_forgotten_password' },
  },
  {
    path: AppRoute.Registration,
    loadChildren: () => import('./feature/registration/registration.routes').then((m) => m.REGISTRATION_ROUTES),
    data: { title: 'page_names.register' },
  },
  {
    path: AppRoute.Downloads,
    loadChildren: () => import('./feature/downloads/downloads.module').then((m) => m.DownloadsModule),
    data: { title: 'page_names.downloads' },
  },
  {
    path: AppRoute.EmailValidation,
    loadChildren: () =>
      import('./feature/email-validation/email-validation.routes').then((m) => m.EMAIL_VALIDATION_ROUTES),
    data: { title: 'page_names.email_validation' },
  },
  {
    path: AppRoute.EinreichungOld,
    loadChildren: () => import('./feature/einreichung/einreichung-old.module').then((m) => m.EinreichungOldModule),
    canActivate: [authGuard, hasSecondFactor, isEinreichungV3ActivatedGuard],
    data: { title: 'page_names.einreichung', reverseEinreichungV3Check: true },
  },
  {
    path: AppRoute.EinreichungNew,
    canActivate: [authGuard, hasSecondFactor, isEinreichungV3ActivatedGuard],
    loadChildren: () => import('@ebeihilfe/einreichung-new/einreichung.routes').then((m) => m.einreichungRoutes),
    data: {
      title: 'page_names.einreichung-new',
    },
  },
  {
    path: AppRoute.DashboardPage,
    component: DashboardComponent,
    canActivate: [authGuard, hasSecondFactor],
    data: { title: startPageTitle },
  },
  {
    path: AppRoute.Landing,
    component: DashboardComponent,
    canActivate: [authGuard, hasSecondFactor],
    data: { title: 'page_names.landing' },
  },
  {
    path: AppRoute.Settings,
    loadChildren: () => import('./feature/settings/settings-routes').then((m) => m.SettingsRoutes),
    data: { title: 'page_names.settings.main' },
  },
  {
    path: AppRoute.Videos,
    loadChildren: () => import('./feature/videos/videos.module').then((m) => m.VideosModule),
    data: { title: 'page_names.videos' },
  },
  {
    path: AppRoute.AntragOverview,
    loadChildren: () =>
      import('./feature/antrags-uebersicht/antrags-uebersicht.module').then((m) => m.AntragsUebersichtModule),
    canActivate: [authGuard, hasSecondFactor, isEinreichungV3ActivatedGuard],
    data: { title: 'page_names.antrags_übersicht', reverseEinreichungV3Check: true },
  },
  {
    path: AppRoute.Bescheid,
    loadChildren: () => import('./feature/bescheide').then((c) => c.BESCHEID_ROUTES),
    canActivate: [authGuard, hasSecondFactor],
    data: { title: 'page_names.bescheide' },
  },
  {
    path: AppRoute.Info,
    loadChildren: () =>
      import('./feature/static-customer-file-viewer/static-customer-file-viewer.module').then(
        (m) => m.StaticCustomerFileViewerModule,
      ),
  },
  // {
  //   path: AppRoute.NewsFeed,
  //   loadChildren: () => import('@ebeihilfe/news-feed').then((m) => m.NewsFeedModule),
  // },
  {
    component: HelpComponent,
    path: AppRoute.Help,
    data: { title: 'page_names.faq' },
  },
  {
    path: AppRoute.NotFound,
    component: NotFound404Component,
    data: { title: 'Page Not Found' },
  },
  {
    path: '',
    pathMatch: 'full',
    component: StartPageComponent,
    canActivate: [goToDashboardIfLoggedIn],
    data: { title: startPageTitle },
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: AppRoute.NotFound,
  },
];
